export default __webpack_public_path__ + "static/media/ongdia-small-min.ac735c07.png";